/**
 * Mirrors the backend `Synerion.Core.Enumerations.ShiftOfferRecipientStatus`
 * enum — the lifecycle of a single employee's row on a Shift Offer.
 */

export enum ShiftOfferRecipientStatusEnum {
  OFFERED = 0,
  PENDING = 1,
  DECLINED = 2,
  APPROVED = 3,
  REJECTED = 4,
  CANCELLED = 5,
  EXPIRED = 6,
}
